import React from 'react'

const StructuredTextFileList = () => {
  return (
    <div>StructuredTextFileList</div>
  )
}

export default StructuredTextFileList